export function isPositive(value: any): boolean {
  if (Number.isNaN(value)) {
    return false;
  }

  return Number(value) > 0;
}
